import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcIrRegularWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.659 21.9755L13.5757 19.0589C13.9858 18.6488 13.9858 17.984 13.5757 17.5739L10.659 14.6573C10.249 14.2472 9.58416 14.2472 9.17411 14.6573C8.76406 15.0673 8.76406 15.7321 9.17411 16.1422L10.3152 17.2833H8.1668C5.97607 17.2833 4.20013 19.0592 4.20013 21.2499C4.20013 23.4407 5.97607 25.2166 8.1668 25.2166H22.7501C23.33 25.2166 23.8001 24.7465 23.8001 24.1666C23.8001 23.5867 23.33 23.1166 22.7501 23.1166H8.1668C7.13587 23.1166 6.30013 22.2809 6.30013 21.2499C6.30013 20.219 7.13587 19.3833 8.1668 19.3833H10.2815L9.17411 20.4906C8.76406 20.9007 8.76406 21.5655 9.17411 21.9755C9.58416 22.3856 10.249 22.3856 10.659 21.9755Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.9586 3.55857C12.5575 3.19182 11.9428 3.19182 11.5416 3.55857L8.62496 6.22515C8.19697 6.61644 8.16722 7.2806 8.55851 7.70859C8.9498 8.13658 9.61396 8.16633 10.0419 7.77504L11.2001 6.71617V10.0576C11.2001 11.9861 12.7635 13.5495 14.692 13.5495H19.8334C20.8644 13.5495 21.7001 14.3852 21.7001 15.4162C21.7001 16.4471 20.8644 17.2828 19.8334 17.2828H16.3334C15.7535 17.2828 15.2834 17.7529 15.2834 18.3328C15.2834 18.9127 15.7535 19.3828 16.3334 19.3828H19.8334C22.0242 19.3828 23.8001 17.6069 23.8001 15.4162C23.8001 13.2254 22.0242 11.4495 19.8334 11.4495H14.692C13.9233 11.4495 13.3001 10.8263 13.3001 10.0576V6.71616L14.4583 7.77504C14.8863 8.16633 15.5504 8.13658 15.9417 7.70859C16.333 7.2806 16.3033 6.61644 15.8753 6.22515L12.9586 3.55857Z",
		fill: "#E2EBFE"
	})]
});
export default SvgIcIrRegularWhite;
